// Generated by ReScript, PLEASE EDIT WITH CARE

import * as N_RnrConfig from "../store/N_RnrConfig.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(categoryName) {
  switch (categoryName) {
    case "CUSTOMER_EXPERIENCE" :
        return /* CustomerService */0;
    case "LOGIN_ACTIVITY" :
        return /* LoginActivity */1;
    case "ORDER_FULFILLMENT" :
        return /* OrderFulfillment */2;
    default:
      return ErrorUtils$Catalyst.raiseError(N_RnrConfig.reward_category_em_error_path, N_RnrConfig.reward_category_em_error_message, categoryName);
  }
}

function toString(categoryName) {
  switch (categoryName) {
    case /* CustomerService */0 :
        return "CUSTOMER_EXPERIENCE";
    case /* LoginActivity */1 :
        return "LOGIN_ACTIVITY";
    case /* OrderFulfillment */2 :
        return "ORDER_FULFILLMENT";
    
  }
}

function toDisplayString(categoryName) {
  switch (categoryName) {
    case /* CustomerService */0 :
        return "Customer Service";
    case /* LoginActivity */1 :
        return "Login Activity";
    case /* OrderFulfillment */2 :
        return "Order Fulfillment";
    
  }
}

export {
  fromString ,
  toString ,
  toDisplayString ,
  
}
/* N_RnrConfig Not a pure module */
